import { LoadingOutlined } from '@ant-design/icons';
import { Col, Collapse, Row, Table, Tooltip, Typography } from 'antd';
import Images from 'app/assets/img';
import { ReactComponent as CancelOrderIcon } from 'app/assets/img/cancel_order_icon.svg';
import { ReactComponent as CancelOrderIconDisable } from 'app/assets/img/cancel_order_icon_disable.svg';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import StyledPagination from 'app/components/StyledPagination';
import StyledGradientDivider from 'app/components/StyledPagination/StyledGradientDivider';
import StyledTable from 'app/components/StyledTable';
import useTitleSize from 'app/components/StyledTable/useTitleSize';
import { Permission } from 'app/hooks/usePermission';
import useWindowSize from 'app/hooks/useWindowSize';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import {
  I_DetailTicket,
  I_Paginator,
  I_PayloadGetListOrder,
  OrderType,
} from 'app/pages/Account/ListOrder/slice/types';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import ColTicketInfo from 'app/pages/NewAccount/components/ColTicketInfo';
import NodataView from 'app/pages/NewAccount/components/NodataView';
import StyledDivider from 'app/pages/NewAccount/components/StyledDivider';
import TicketInfoTitle from 'app/pages/NewAccount/components/TicketInfoTitle';
import useGetDetailTicket from 'app/pages/NewAccount/hooks/useGetDetailTicket';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import { OrderState } from 'app/pages/NewAccount/types';
import { cancelOrderApi } from 'app/services/authApi';
import { cancelUpgradeTicketApi } from 'app/services/checkTicketApi';
import { te } from 'date-fns/locale';
import { translations } from 'locales/translations';
import moment from 'moment';
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { objectType } from 'types';
import { BP_TYPE, TYPE_LOCAL_STORAGE } from 'utils/constants';
import { DateFormat } from 'utils/date-utils/date-format';
import {
  clickToDownload,
  formatNumber,
  isAndroid,
  windowOpenLink,
} from 'utils/helper';
import useCountDown from 'utils/hooks/useCountDown';
import { setSessionItem } from 'utils/localStorage';
import { parseSecondsToMinutesAndHours } from 'utils/time';
import { APPROVAL_ORDER_STATUS } from '../ApproveOrder';
import RenderIf from 'app/components/RenderIf';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { StyledPopover } from '../CheckTickets/styled';
import { isArray } from 'lodash';

export type EvoucherViewType = {
  productName?: string;
  code?: string;
};

export interface TicketType {
  _id: string;
  orderInfo: OrderInfo;
  paymentInfo: PaymentInfo;
  ticketInfo?: TicketInfo & {
    selectedDate: string;
  };
  giftsInfo?: (TicketInfo & {
    orgTickets: I_DetailTicket[];
    amount: number;
    selectedDate: string;
    higherLevelItem: string;
  })[];
  ticketsInfo?: (TicketInfo & {
    orgTickets: I_DetailTicket[];
    amount: number;
    selectedDate: string;
    show?: { usedArea2Label: string };
  })[];
  ticketBlocks?: any;
  vouchers?: EvoucherViewType[];
  orderDate?: {
    time: string;
    date: string;
    datetime: string;
    dateDMY: string;
    datetimeDMY: string;
    dateOrigin: string;
    datetimeDMYHIS: string;
  };
  expiredAt?: {
    time: string;
    date: string;
    datetime: string;
    dateDMY: string;
    datetimeDMY: string;
    dateOrigin: string;
    datetimeDMYHIS: string;
  };
  orderState?: any;
  pathTicketPdf?: string;
  totalTicket?: number;
  orderType?: any;
  items?: any;
  giftItems?: any;
  orderIdChanged?: string;
  refundAmount?: number;
  differenceAmount?: number;
  startTime?: {
    time: string;
    date: string;
    datetime: string;
    dateDMY: string;
    datetimeDMY: string;
    dateOrigin: string;
    datetimeDMYHIS: string;
  };
  totalGiftItems?: number;
  orderPaying?: boolean;
  agent?: any;
  representativesInfo?: {
    name: string;
    phone: string;
    email: string;
    position: string;
  }[];
  isLongTerm?: boolean;
  mailAuthorizedBiz?: string | null;
  emailBpAllocatedDebt?: string | null;
  adjustAttach?: string | null;
  adjustedPriceOrFOC?: boolean | null;
  approvedDate?: {
    time: string;
    date: string;
    datetime: string;
    dateDMY: string;
    datetimeDMY: string;
    dateOrigin: string;
    datetimeDMYHIS: string;
  };
  approveReason?: string | null;
}
export interface TicketInfo {
  eventName: string;
  serial: string;
  ticketName: string;
  useDate: string;
  useHour?: string;
  position: string;
  price: number;
  imgPath?: string;
  dataBuyer?: {
    email: string;
    identityCode: string;
  }[];
  isComboTicket: boolean;
  useDateFrom: string;
  numberAddDays: number;
  expiredAt?: {
    time: string;
    date: string;
    datetime: string;
    dateDMY: string;
    datetimeDMY: string;
    dateOrigin: string;
    datetimeDMYHIS: string;
  };
  orderdate?: any;
  orderIdChanged?: string;
  refundAmount?: number;
  differenceAmount?: number;
}
interface PaymentInfo {
  customerName: string;
  phoneNumber: string;
  email: string;
}
interface OrderInfo {
  orderId: string;
  amountOfTicket: number;
  orderDate: string;
  totalDiscountValue: number;
  totalPriceValue: number;
  payment?: { id: number; name: string; code: string };
}

export type ListTicketLayoutProps = {
  loading: boolean;
  listTicket: TicketType[];
  paginator?: I_Paginator;
  search?: (payload: Partial<I_PayloadGetListOrder>) => void;
  orderState: OrderState;
  getListOrderOnCancelOrderSuccess?: () => void;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
  activeKeyTab?: string;
};

const getNodataText = (
  orderState: OrderState,
  translations: objectType | undefined,
) => {
  switch (orderState) {
    case 'success':
      return translations ? translations['b2c.txt.nodataSuccess'] : '';
    case 'paymentPending':
      return translations ? translations['b2c.txt.nodataPaymentPending'] : '';
    case 'cancelled':
      return translations ? translations['b2c.txt.nodataCancelled'] : '';
    case 'init':
      return translations ? translations['b2c.txt.nodataInit'] : '';
    case 'approved,pendingApprove':
      return translations ? translations['b2c.txt.nodataWaitApprove'] : '';
    default:
      break;
  }
};

export const RepresentativeList = ({
  representativesInfo,
}: {
  representativesInfo?: any;
}) => {
  const { device } = useWindowSize();
  const translations = useSelector(selectTranslations);
  return (
    <LoadingContainer minHeight={'100px'} loading={false}>
      <StyledTable
        dataSource={representativesInfo}
        emptyText={translations?.['b2b.txt.haveNoTicketSelected'] ?? ''}
        columns={[
          {
            title: (
              <div style={{ textAlign: 'left' }}>
                {translations?.['b2b.txt.name'] ?? 'Họ và tên'}
              </div>
            ),
            key: 'name',
            render: val => {
              return <div style={{ textAlign: 'left' }}>{val.name}</div>;
            },
          },
          {
            title: (
              <div style={{ textAlign: 'left' }}>
                {translations?.['b2b.txt.phone'] ?? 'Số điện thoại'}
              </div>
            ),
            key: 'phone',
            render: val => {
              return <div style={{ textAlign: 'left' }}>{val.phone}</div>;
            },
          },
          {
            title: (
              <div style={{ textAlign: 'left' }}>
                {translations?.['b2b.acc.email'] ?? 'Email'}
              </div>
            ),
            key: 'email',
            render: val => {
              return <div style={{ textAlign: 'left' }}>{val.email}</div>;
            },
          },
          {
            title: (
              <div style={{ textAlign: 'left' }}>
                {translations?.['b2b.txt.position'] ?? 'Chức danh'}
              </div>
            ),
            key: 'position',
            render: val => {
              return (
                <div style={{ textAlign: 'left' }}>
                  {translations?.[`b2b.txt.${val.position}`]}
                </div>
              );
            },
          },
        ]}
        scroll={{
          x: device === 'desktop' ? 'auto' : 1000,
        }}
        pagination={false}
        styleSlots={{
          th: {
            backgroundColor: '#ff7a00',
            color: 'white',
          },
          antTableContainer: {
            paddingBottom: 0,
            width: device === 'desktop' ? 'auto' : 350,
          },
        }}
      />
    </LoadingContainer>
  );
};

const formatDate = (
  date: moment.Moment,
  format: (dayOfWeek: string, date: moment.Moment) => string,
) => {
  const DAYS_OF_WEEK_VI = [
    'Chủ Nhật',
    'Thứ 2',
    'Thứ 3',
    'Thứ 4',
    'Thứ 5',
    'Thứ 6',
    'Thứ 7',
  ];
  const dayOfWeek = DAYS_OF_WEEK_VI[date.day()];
  // Format the rest of the date
  return format(dayOfWeek, date);
};

const ListTicketLayout = ({
  listTicket,
  paginator,
  search,
  orderState,
  getListOrderOnCancelOrderSuccess,
  setIsLoading,
  activeKeyTab,
}: ListTicketLayoutProps) => {
  const formatString = 'HH:mm:ss DD/MM/YYYY';
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const { onClickShowDetail, isGetingDetail } = useGetDetailTicket({
    screen: '/account',
    setIsLoading,
  });
  const history = useHistory();

  const titleColumnSizes = useTitleSize({
    title: [
      'b2b.txt.implement-date',
      'b2c.txt.date-order',
      'b2c.txt.orderNumber',
      'b2b.txt.orderNumberChange',
      'b2c.txt.ticketAmount',
      'b2b.txt.list-order-type',
      'b2c.txt.pttt',
      'b2b.txt.total-discount',
      'b2c.txt.total-amount',
      'b2b.txt.orderer',
      'b2b.txt.canceller',
      'b2b.txt.order-status',
      'b2b.txt.ticket-status',
      'b2b.txt.bill',
      'b2b.txt.payIn',
      'b2b.txt.action',
      'b2b.txt.contactType.representative',
      'b2b.txt.authorized',
      'b2b.txt.ticketBooker',
      'b2b.txt.ticketRecipient',
      'b2b.txt.approvalCode',
      'b2b.txt.source',
      'b2b.txt.sapCode',
    ],
  });

  const columns = useMemo(
    () =>
      [
        {
          title: (
            <div style={{ textAlign: 'left', marginLeft: 20 }}>
              {orderState === 'approved,pendingApprove' || orderState === 'init'
                ? translations?.['b2b.txt.implement-date']
                : translations?.['b2c.txt.date-order']}
            </div>
          ),
          dataIndex: 'orderDate',
          key: 'orderDate',
          render: orderDate => {
            const newDate = moment(orderDate?.datetimeDMYHIS, formatString);
            if (newDate.toString() === 'Invalid date')
              return (
                <div
                  style={{
                    minWidth:
                      titleColumnSizes[
                        orderState === 'approved,pendingApprove' ||
                        orderState === 'init'
                          ? 'b2b.txt.implement-date'
                          : 'b2c.txt.date-order'
                      ],
                  }}
                />
              );
            return (
              <div
                style={{
                  textAlign: 'left',
                  marginLeft: 20,
                  minWidth:
                    titleColumnSizes[
                      orderState === 'approved,pendingApprove' ||
                      orderState === 'init'
                        ? 'b2b.txt.implement-date'
                        : 'b2c.txt.date-order'
                    ],
                }}
              >
                <Typography>{newDate.format('DD/MM/YYYY')}</Typography>
                <Typography>{newDate.format('HH:mm:ss')}</Typography>
              </div>
            );
          },
        },
        {
          title: translations?.['b2c.txt.orderNumber'],
          key: 'orderInfo.orderId',
          render: ticket => (
            <div
              style={{
                color:
                  orderState === 'approved,pendingApprove' ||
                  orderState === 'init'
                    ? '#8c8c8c'
                    : '#F8B117',
                cursor: isGetingDetail
                  ? 'progress'
                  : orderState === 'approved,pendingApprove' ||
                    orderState === 'init'
                  ? undefined
                  : 'pointer',
                minWidth: titleColumnSizes['b2c.txt.orderNumber'],
              }}
              onClick={() => {
                if (isGetingDetail) return;
                if (
                  orderState === 'approved,pendingApprove' ||
                  orderState === 'init'
                ) {
                  return;
                }
                if (ticket.orderType?.value === 'return') {
                  if (
                    ticket.orderState?.value === 'approved' ||
                    ticket.orderState?.value === 'pendingApprove' ||
                    ticket.orderState?.value === 'success'
                  ) {
                    history.push(`/ticket-refund/detail/${ticket._id}`);
                  } else if (ticket.orderState?.value === 'init') {
                    history.push(`/ticket-refund/info/${ticket._id}`, {
                      prevPage: '/account',
                    });
                  } else if (ticket.orderState?.value === 'cancelled') {
                    history.push(`/ticket-refund/detail/${ticket._id}`, {
                      prevPage: '/account',
                      targetTab: 'tab-3',
                    });
                  }
                } else if (ticket.orderType?.value === 'upgrade') {
                  history.push(`/check-tickets/exchange-detail/${ticket._id}`, {
                    screen: '/account',
                  });
                } else {
                  onClickShowDetail(ticket?._id);
                }
              }}
            >
              {!!ticket?.thirdPartySubmitNumber
                ? ticket?.thirdPartySubmitNumber
                : ticket.orderInfo?.orderId}
            </div>
          ),
        },
        {
          title: translations?.['b2b.txt.orderNumberChange'],
          key: 'orderIdChanged',
          render: ticket => (
            <div
              style={{
                color: '#F8B117',
                cursor: isGetingDetail ? 'progress' : 'pointer',
                minWidth: titleColumnSizes['b2b.txt.orderNumberChange'],
              }}
              onClick={() => {
                if (isGetingDetail) return;
                onClickShowDetail(`${ticket?.orderIdChanged}`);
              }}
            >
              {ticket.orderIdChanged ?? ''}
            </div>
          ),
        },
        {
          title: translations?.['b2b.txt.sapCode'],
          key: 'orderInfo.sapSubmitNumber',
          render: ticket => (
            <div
              style={{
                minWidth: titleColumnSizes['b2b.txt.sapCode'],
              }}
            >
              {ticket?.sapSubmitNumber}
            </div>
          ),
        },
        {
          title: translations?.['b2c.txt.ticketAmount'],
          dataIndex: 'orderInfo',
          key: 'orderInfo.amountOfTicket',
          render: orderInfo => (
            <div style={{ minWidth: titleColumnSizes['b2c.txt.ticketAmount'] }}>
              {orderInfo?.amountOfTicket}
            </div>
          ),
        },
        {
          // TODO: translation
          title: translations?.['b2b.txt.contactType.representative'],
          dataIndex: 'representativesInfo',
          key: 'representativesInfo',
          render: (representativesInfo, record) => {
            if (
              !isArray(representativesInfo) ||
              !representativesInfo?.length ||
              !representativesInfo?.[0]?.name
            ) {
              return (
                <div
                  style={{
                    minWidth:
                      titleColumnSizes['b2b.txt.contactType.representative'],
                  }}
                />
              );
            }

            return (
              <StyledPopover
                overlayClassName="representative-popover"
                overlayInnerStyle={{ padding: 0 }}
                content={
                  representativesInfo.length > 0 ? (
                    <RepresentativeList
                      representativesInfo={representativesInfo}
                    />
                  ) : null
                }
              >
                <div
                  style={{
                    minWidth:
                      titleColumnSizes['b2b.txt.contactType.representative'],
                  }}
                >{`${representativesInfo?.[0]?.name}${
                  representativesInfo.length >= 2
                    ? `,+${representativesInfo.length - 1}`
                    : ''
                }`}</div>
              </StyledPopover>
            );
          },
        },
        {
          title: translations?.['b2b.txt.list-order-type'],
          dataIndex: 'orderType',
          key: 'order-ordertype',
          render: value => {
            return (
              <div
                style={{
                  minWidth: titleColumnSizes['b2b.txt.list-order-type'],
                }}
              >
                {value?.name}
              </div>
            );
          },
        },
        orderState !== 'approved,pendingApprove' &&
          orderState !== 'init' && {
            title: translations?.['b2c.txt.pttt'],
            dataIndex: 'orderInfo',
            key: 'orderInfo.payment',
            render: orderInfo => (
              <div style={{ minWidth: titleColumnSizes['b2c.txt.pttt'] }}>
                {orderInfo?.payment?.name}
              </div>
            ),
          },
        !isProxyBuyer && {
          title: translations?.['b2b.txt.source'],
          dataIndex: 'orderSourceName',
          key: 'orderSourceName',
          render: source => {
            return (
              <div style={{ minWidth: titleColumnSizes['b2b.txt.source'] }}>
                {source}
              </div>
            );
          },
        },
        isProxyBuyer && {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.authorized']}
            </div>
          ),
          render: value => {
            return (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  minWidth: titleColumnSizes['b2b.txt.authorized'],
                }}
              >
                <TooltipParagraph
                  ellipsis={{ rows: 1 }}
                  style={{
                    marginBottom: 0,
                    maxWidth: 164,
                    textAlign: 'center',
                  }}
                >
                  {value?.authorizedBiz}
                </TooltipParagraph>
              </div>
            );
          },
        },
        orderState !== 'approved,pendingApprove' &&
          orderState !== 'init' && {
            title: (
              <div style={{ textAlign: 'right' }}>
                {translations?.['b2b.txt.total-discount']}
              </div>
            ),
            dataIndex: 'orderInfo',
            key: 'orderInfo.totalDiscountValue',
            render: orderInfo => (
              <div
                style={{
                  textAlign: 'right',
                  minWidth: titleColumnSizes['b2b.txt.total-discount'],
                }}
              >
                {formatNumber(-orderInfo?.totalDiscountValue).replaceAll(
                  ',',
                  '.',
                ) + 'đ'}
              </div>
            ),
          },
        orderState !== 'init' && {
          title: (
            <div style={{ textAlign: 'right' }}>
              {translations?.['b2c.txt.total-amount']}
            </div>
          ),
          key: 'orderInfo.totalPriceValue',
          render: value => {
            // const isUpgrade = value?.orderType?.value === 'upgrade';
            // const displayValue = isUpgrade
            //   ? value?.differenceAmount
            //   : value?.orderInfo?.totalPriceValue;
            const displayValue = value?.orderInfo?.totalPriceValue;
            const prefix =
              value?.orderType?.value === 'return' &&
              Number(displayValue) > 0 &&
              orderState === 'success'
                ? '-'
                : '';
            return (
              <div
                style={{
                  textAlign: 'right',
                  minWidth: titleColumnSizes['b2c.txt.total-amount'],
                }}
              >
                {prefix + formatNumber(displayValue).replaceAll(',', '.') + 'đ'}
              </div>
            );
          },
        },
        isProxyBuyer && {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.ticketRecipient']}
            </div>
          ),
          render: value => (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                minWidth: titleColumnSizes['b2b.txt.ticketRecipient'],
              }}
            >
              <TooltipParagraph
                ellipsis={{ rows: 1 }}
                style={{
                  marginBottom: 0,
                  maxWidth: 164,
                  textAlign: 'center',
                }}
              >
                {value?.mailAuthorizedBiz}
              </TooltipParagraph>
            </div>
          ),
        },
        {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.orderer']}
            </div>
          ),
          key: 'value',
          // render: value => value?.agent?.name,
          render: value => (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                minWidth: titleColumnSizes['b2b.txt.orderer'],
              }}
            >
              <TooltipParagraph
                ellipsis={{ rows: 1 }}
                style={{
                  marginBottom: 0,
                  maxWidth: 164,
                  textAlign: 'center',
                }}
              >
                {value?.agent?.name}
              </TooltipParagraph>
            </div>
          ),
        },
        isProxyBuyer &&
          !!activeKeyTab &&
          ['tab-1', 'tab-2', 'tab-3'].includes(activeKeyTab) && {
            title: (
              <div style={{ textAlign: 'center' }}>
                {translations?.['b2b.txt.approvalCode']}
              </div>
            ),
            key: 'value',
            render: value => (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  minWidth: titleColumnSizes['b2b.txt.approvalCode'],
                }}
              >
                <TooltipParagraph
                  ellipsis={{ rows: 1 }}
                  style={{
                    marginBottom: 0,
                    maxWidth: 164,
                    textAlign: 'center',
                  }}
                >
                  {value?.approvedCode}
                </TooltipParagraph>
              </div>
            ),
          },
        orderState === 'paymentPending' && {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.order-status']}
            </div>
          ),
          key: 'subOrderState',
          dataIndex: 'subOrderState',
          render: subOrderState => {
            return (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  minWidth: titleColumnSizes['b2b.txt.order-status'],
                }}
              >
                <RenderIf
                  condition={
                    subOrderState?.value === APPROVAL_ORDER_STATUS.SUCCESS
                  }
                  fallback={<>{subOrderState?.name}</>}
                >
                  <>{translations?.['b2b.txt.approved'] ?? ''}</>
                </RenderIf>
              </div>
            );
          },
        },
        orderState === 'cancelled' && {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.canceller']}
            </div>
          ),
          key: 'value',
          render: value => (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                minWidth: titleColumnSizes['b2b.txt.canceller'],
              }}
            >
              <TooltipParagraph
                ellipsis={{ rows: 1 }}
                style={{
                  marginBottom: 0,
                  maxWidth: 164,
                  textAlign: 'center',
                }}
              >
                {value?.canceller ?? ''}
              </TooltipParagraph>
            </div>
          ),
        },
        orderState === 'approved,pendingApprove' && {
          title: translations?.['b2b.txt.order-status'],
          key: 'order-status',
          // render: value => value?.agent?.name,
          render: value => (
            <div style={{ minWidth: titleColumnSizes['b2b.txt.order-status'] }}>
              {value?.orderState?.name}
            </div>
          ),
        },
        orderState === 'success' && {
          title: translations?.['b2b.txt.ticket-status'],
          key: 'orderInfoType',
          render: object => {
            if (!object?.orderState?.value)
              return (
                <div
                  style={{
                    minWidth: titleColumnSizes['b2b.txt.ticket-status'],
                  }}
                />
              );
            if (object?.orderType?.value === 'return') {
              return (
                <div
                  style={{
                    minWidth: titleColumnSizes['b2b.txt.ticket-status'],
                  }}
                />
              );
            }
            return (
              <div
                style={{ minWidth: titleColumnSizes['b2b.txt.ticket-status'] }}
              >
                {object?.orderState?.value === 'success'
                  ? translations?.['b2b.txt.ticket-exported']
                  : translations?.['b2b.txt.ticket-exporting']}
              </div>
            );
          },
        },
        orderState === 'success' && {
          title: translations?.['b2b.txt.bill'],
          key: 'orderStateId',
          render: value => {
            switch (value?.orderType?.value) {
              case 'return':
                return (
                  <div style={{ minWidth: titleColumnSizes['b2b.txt.bill'] }}>
                    {value?.returnSeq?.split(',')?.map(i => (
                      <span key={i} className="d-block">
                        {i}
                      </span>
                    ))}
                  </div>
                );
              case 'upgrade':
                return (
                  <div style={{ minWidth: titleColumnSizes['b2b.txt.bill'] }}>
                    {value?.seq?.split(',')?.map(i => (
                      <span key={i} className="d-block">
                        {i}
                      </span>
                    ))}
                    <br />
                    {value?.changeSeq?.split(',')?.map(i => (
                      <span key={i} className="d-block">
                        {i}
                      </span>
                    ))}
                  </div>
                );
              default:
                return (
                  <div style={{ minWidth: titleColumnSizes['b2b.txt.bill'] }}>
                    {value?.seq?.split(',')?.map(i => (
                      <span key={i} className="d-block">
                        {i}
                      </span>
                    ))}
                  </div>
                );
            }
          },
        },
        (orderState === 'paymentPending' || orderState === 'init') && {
          title: translations?.['b2b.txt.payIn'],
          key: 'paymentInfo.customerName',
          render: value => {
            return (
              <div style={{ minWidth: titleColumnSizes['b2b.txt.payIn'] }}>
                {value?.expiredAt && (
                  <Countdown
                    onTimeout={() => {
                      search?.({});
                    }}
                    orderCheckout={value}
                    noText
                  />
                )}
              </div>
            );
          },
        },
        orderState !== 'cancelled' &&
          !(isProxyBuyer && orderState === 'success') && {
            title: translations?.['b2b.txt.action'],
            key: 'action',
            render: value => {
              return (
                <div style={{ minWidth: titleColumnSizes['b2b.txt.action'] }}>
                  {value?.id && (
                    <ActionButtonsView
                      isDisable={
                        orderState === 'approved,pendingApprove' ||
                        (orderState === 'init' &&
                          value.orderType?.value !== 'upgrade')
                          ? false
                          : value?.agent?.id !== infoUser?.id
                      }
                      ticket={value}
                      onClickShowDetail={ticket =>
                        onClickShowDetail(ticket?._id)
                      }
                      isGetingDetail={isGetingDetail}
                      orderState={orderState}
                      subOrderState={value?.subOrderState}
                    />
                  )}
                </div>
              );
            },
          },
      ].filter(item => typeof item !== 'boolean'),
    [
      history,
      infoUser?.id,
      isGetingDetail,
      onClickShowDetail,
      orderState,
      search,
      translations,
      titleColumnSizes,
      isProxyBuyer,
      activeKeyTab,
    ],
  );

  const dataSourceFormatted = useMemo(() => {
    const total = listTicket.reduce(
      (obj: any, ticket) => {
        obj.totalDiscountValue += Number(
          ticket?.orderInfo?.totalDiscountValue || 0,
        );
        if (ticket?.orderType?.value === 'return' && orderState === 'success') {
          obj.totalPriceValue -= Number(
            ticket?.orderInfo?.totalPriceValue || 0,
          );
        } else if (ticket?.orderType?.value === 'upgrade') {
          obj.totalPriceValue += ticket?.differenceAmount;
        } else {
          obj.totalPriceValue += Number(
            ticket?.orderInfo?.totalPriceValue || 0,
          );
        }
        return obj;
      },
      {
        totalDiscountValue: 0,
        totalPriceValue: 0,
        payment: { name: translations?.['b2c.txt.total'] },
      },
    );
    return [...listTicket, { orderInfo: total }];
  }, [listTicket, orderState, translations]);

  const tableRef = useRef<any>();

  return (
    <>
      {listTicket.length > 0 ? (
        <div style={{ marginTop: 10 }}>
          <StyledTable
            tableRef={tableRef}
            dataSource={dataSourceFormatted}
            columns={columns as object[]}
            pagination={false}
            tableProps={{
              rowKey: (record, index) =>
                `${(record as TicketType)._id}${index}`,
              scroll: {
                y: '50vh',
                x: 'auto',
              },
            }}
            styleSlots={{
              footerCSS: {
                backgroundColor: '#f5f5f5',
                fontWeight: 'bold',
              },
              antTableContainer: {
                overflow: 'hidden',
              },
              antTableHeader: {
                border: 'none !important',
                borderRadius: '0 !important',
              },
              tableCSS: {
                borderTopLeftRadius: '0 !important',
                borderTopRightRadius: '0 !important',
              },
              antTableBody: {
                paddingBottom: 10,
              },
            }}
            // tableProps={rowKey:(record, index) => `${(record as TicketType)._id}${index}`}
          />
          {paginator && (
            <>
              {/* <StyledGradientDivider style={{ marginTop: '40px' }} /> */}
              <StyledPagination
                style={{
                  marginTop: '40px',
                }}
                showSizeChanger
                // defaultCurrent={1}
                current={paginator.current}
                total={paginator.totalCount} // Total number of data items
                pageSize={paginator.numItemsPerPage} // Number of items per page
                onChange={(page, pageSize) => {
                  window.scrollTo(0, 0);
                  search && search({ page, limit: pageSize });
                  tableRef?.current
                    ?.querySelector('.ant-table-body')
                    ?.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                }} // Function to call when the page changes
                pageSizeOptions={['20', '50', '100']}
              />
            </>
          )}
        </div>
      ) : (
        <NodataView text={getNodataText(orderState, translations)} />
      )}
    </>
  );
};
const LIMIT = 50;
const ActionButtonsView = (props: {
  orderState: OrderState;
  ticket: TicketType;
  onClickShowDetail: (value: TicketType) => void;
  isGetingDetail: boolean;
  isDisable: boolean;
  subOrderState?: { name: string; value: string };
}) => {
  const {
    orderState,
    onClickShowDetail,
    ticket,
    isGetingDetail,
    isDisable,
    subOrderState,
  } = props;
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const isProxyOrder = !!ticket.mailAuthorizedBiz;

  const isPendingConfirm =
    subOrderState?.value === APPROVAL_ORDER_STATUS.PENDING;

  const isRefureConfirm = subOrderState?.value === APPROVAL_ORDER_STATUS.REFUSE;

  const isHadUpdated = (ticket as any)?.hadUpdated;

  const isAdjustedPriceOrFOC = !!ticket.adjustedPriceOrFOC;

  const isPartnerViewAdjustedFocOrPriceOrder =
    isProxyOrder && !isProxyBuyer && isAdjustedPriceOrFOC;

  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const [warning, setWarning] = useState({
    open: false,
    message: '',
  });
  const isHaveTicketSerial = useMemo(() => {
    const requireRender = Number(ticket?.totalTicket || 0) > 50;
    return (
      ticket?.orderState?.value === 'success' &&
      ((requireRender && !!ticket.pathTicketPdf) || !requireRender)
    );
  }, [ticket?.orderState?.value, ticket.pathTicketPdf, ticket?.totalTicket]);
  const isRefundOrder = useMemo(() => {
    return ticket?.orderType?.value === 'return';
  }, [ticket]);
  const disableStyle: React.CSSProperties = {
    pointerEvents: 'none',
    filter: 'contrast(0)',
    cursor: 'no-drop',
  };
  const payOrder = useCallback(async () => {
    // setSessionItem(TYPE_LOCAL_STORAGE.ORDER, JSON.stringify(ticket._id));
    if (ticket?.orderType?.value === 'upgrade') {
      history.push('/check-tickets/confirm-policy-order/' + ticket._id, {
        menu: ACCOUNT_MNG_MENU.PURCHASE_HISTORY,
      });
    } else {
      history.push('/checkout/' + ticket._id);
    }
  }, [history, ticket._id]);

  const urlSuffix = useMemo(() => {
    if ((ticket?.totalGiftItems || 0) > 0 || (ticket?.totalTicket || 0) > 1) {
      return '';
    } else {
      return '?totalTicket=1';
    }
  }, [ticket?.totalGiftItems, ticket?.totalTicket]);

  return (
    <StyledStack
      columnGap={'12px'}
      justifyContent={
        orderState === 'approved,pendingApprove' || orderState === 'init'
          ? 'center'
          : undefined
      }
    >
      {orderState === 'success' && (
        <Tooltip
          color="white"
          title={
            translations?.[
              ticket?.isLongTerm
                ? 'b2b.txt.download-file-ticket'
                : 'b2c.txt.viewPDF'
            ]
          }
          overlayInnerStyle={{ color: 'black' }}
        >
          <StyledButton
            bgColor="white"
            style={{
              padding: 0,
              width: 30,
              height: 30,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor:
                isHaveTicketSerial && !isRefundOrder ? 'pointer' : 'no-drop',
            }}
          >
            {ticket?.isLongTerm ? (
              <a
                href={ticket?.pathTicketPdf}
                style={{
                  pointerEvents:
                    ticket?.isLongTerm && !!ticket?.pathTicketPdf
                      ? 'auto'
                      : 'none',
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5625 11.1377C0.711684 11.1377 0.854758 11.197 0.960248 11.3024C1.06574 11.4079 1.125 11.551 1.125 11.7002V14.5127C1.125 14.8111 1.24353 15.0972 1.4545 15.3082C1.66548 15.5192 1.95163 15.6377 2.25 15.6377H15.75C16.0484 15.6377 16.3345 15.5192 16.5455 15.3082C16.7565 15.0972 16.875 14.8111 16.875 14.5127V11.7002C16.875 11.551 16.9343 11.4079 17.0398 11.3024C17.1452 11.197 17.2883 11.1377 17.4375 11.1377C17.5867 11.1377 17.7298 11.197 17.8352 11.3024C17.9407 11.4079 18 11.551 18 11.7002V14.5127C18 15.1094 17.7629 15.6817 17.341 16.1037C16.919 16.5256 16.3467 16.7627 15.75 16.7627H2.25C1.65326 16.7627 1.08097 16.5256 0.65901 16.1037C0.237053 15.6817 0 15.1094 0 14.5127V11.7002C0 11.551 0.0592632 11.4079 0.164752 11.3024C0.270242 11.197 0.413316 11.1377 0.5625 11.1377Z"
                    fill={
                      ticket?.isLongTerm && !!ticket?.pathTicketPdf
                        ? '#FAB317'
                        : '#979797'
                    }
                  ></path>
                  <path
                    d="M8.60173 13.3358C8.65398 13.3881 8.71605 13.4297 8.78439 13.4581C8.85273 13.4864 8.92599 13.501 8.99998 13.501C9.07397 13.501 9.14723 13.4864 9.21557 13.4581C9.2839 13.4297 9.34598 13.3881 9.39823 13.3358L12.7732 9.96075C12.8789 9.85513 12.9382 9.71187 12.9382 9.5625C12.9382 9.41313 12.8789 9.26987 12.7732 9.16425C12.6676 9.05863 12.5244 8.99929 12.375 8.99929C12.2256 8.99929 12.0824 9.05863 11.9767 9.16425L9.56248 11.5796V1.6875C9.56248 1.53832 9.50322 1.39524 9.39773 1.28975C9.29224 1.18426 9.14916 1.125 8.99998 1.125C8.85079 1.125 8.70772 1.18426 8.60223 1.28975C8.49674 1.39524 8.43748 1.53832 8.43748 1.6875V11.5796L6.02323 9.16425C5.91761 9.05863 5.77435 8.99929 5.62498 8.99929C5.47561 8.99929 5.33235 9.05863 5.22673 9.16425C5.12111 9.26987 5.06177 9.41313 5.06177 9.5625C5.06177 9.71187 5.12111 9.85513 5.22673 9.96075L8.60173 13.3358Z"
                    fill={
                      ticket?.isLongTerm && !!ticket?.pathTicketPdf
                        ? '#FAB317'
                        : '#979797'
                    }
                  ></path>
                </svg>
              </a>
            ) : (
              <a
                href={`/print-tickets/${ticket._id}${urlSuffix}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#F8B117',
                  pointerEvents:
                    isHaveTicketSerial && !isRefundOrder ? 'auto' : 'none',
                }}
              >
                <img
                  src={Images.PdfViewIcon}
                  alt=""
                  style={{
                    filter:
                      isHaveTicketSerial && !isRefundOrder
                        ? 'none'
                        : 'contrast(0)',
                    cursor: 'no-drop',
                  }}
                />
              </a>
            )}
          </StyledButton>
        </Tooltip>
      )}
      {orderState === 'paymentPending' && (
        <Tooltip
          color="white"
          title={translations?.['b2b.txt.pay-now']}
          overlayInnerStyle={{ color: 'black' }}
        >
          <StyledButton
            onClick={() =>
              !isDisable &&
              !isPendingConfirm &&
              (!isRefureConfirm || isHadUpdated) &&
              ((isProxyOrder && isProxyBuyer) || !isProxyBuyer) &&
              payOrder()
            }
            bgColor="white"
            style={{
              width: 30,
              height: 30,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor: isGetingDetail
                ? 'progress'
                : !isDisable &&
                  !isPendingConfirm &&
                  (!isRefureConfirm || isHadUpdated) &&
                  ((isProxyOrder && isProxyBuyer) || !isProxyBuyer)
                ? 'pointer'
                : 'no-drop',
            }}
          >
            <img
              src={Images.PaymentIcon2}
              alt=""
              style={{
                ...((isDisable ||
                  isPendingConfirm ||
                  (isRefureConfirm && !isHadUpdated)) &&
                  disableStyle),
              }}
            />
          </StyledButton>
        </Tooltip>
      )}
      {orderState === 'paymentPending' && (
        <Tooltip
          color="white"
          title={translations?.['b2b.txt.editRepresentativeInfo']}
          overlayInnerStyle={{ color: 'black' }}
        >
          <StyledButton
            onClick={() =>
              !isDisable &&
              ((isProxyOrder && isProxyBuyer) || !isProxyBuyer) &&
              windowOpenLink({
                url: `/update-order-info?order_id=${ticket._id}`,
                target: '_self',
              })
            }
            bgColor="white"
            style={{
              width: 30,
              height: 30,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor: isGetingDetail
                ? 'progress'
                : !isDisable &&
                  ((isProxyOrder && isProxyBuyer) || !isProxyBuyer)
                ? 'pointer'
                : 'no-drop',
            }}
          >
            <img
              src={Images.CustomerIcon}
              alt=""
              style={{ ...(isDisable && disableStyle) }}
            />
          </StyledButton>
        </Tooltip>
      )}
      {orderState === 'paymentPending' && (
        <Tooltip
          color="white"
          title={
            ticket?.orderType?.value !== 'upgrade'
              ? translations?.['b2b.txt.edit-order']
              : translations?.['b2b.upgrade.disable-edit']
          }
          overlayInnerStyle={{ color: 'black' }}
        >
          <StyledButton
            bgColor="white"
            style={{
              width: 30,
              height: 30,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor: isGetingDetail
                ? 'progress'
                : !isDisable &&
                  !isPendingConfirm &&
                  ((isProxyOrder && isProxyBuyer) || !isProxyBuyer) &&
                  ticket?.orderType?.value !== 'upgrade'
                ? 'pointer'
                : 'no-drop',
            }}
            onClick={() => {
              if (
                !isDisable &&
                !isPendingConfirm &&
                ((isProxyOrder && isProxyBuyer) || !isProxyBuyer) &&
                ticket?.orderType?.value !== 'upgrade'
              ) {
                if (ticket?.orderPaying) {
                  setWarning({
                    open: true,
                    message: translations?.['b2b.txt.warning-not-edit-order'],
                  });
                  return;
                }
                history.push(`/order/edit/${ticket._id}`);
              }
            }}
            textColor="white"
            width={'auto'}
          >
            <img
              src={Images.EditIcon}
              alt=""
              style={{
                ...((isDisable ||
                  isPendingConfirm ||
                  ticket?.orderType?.value === 'upgrade') &&
                  disableStyle),
              }}
            />
          </StyledButton>
        </Tooltip>
      )}
      {(orderState === 'approved,pendingApprove' || orderState === 'init') && (
        <Tooltip
          color="white"
          title={translations?.['b2c.txt.detail-order'] ?? ''}
          overlayInnerStyle={{ color: 'black' }}
        >
          <StyledButton
            bgColor="white"
            style={{
              width: 30,
              height: 30,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor:
                !isDisable && !isPartnerViewAdjustedFocOrPriceOrder
                  ? 'pointer'
                  : 'no-drop',
            }}
            onClick={() => {
              if (isDisable) return;
              if (isPartnerViewAdjustedFocOrPriceOrder) return;
              if (ticket.orderType?.value === 'return') {
                if (
                  ticket.orderState?.value === 'approved' ||
                  ticket.orderState?.value === 'pendingApprove'
                ) {
                  history.push(`/ticket-refund/detail/${ticket._id}`, {
                    prevPage: '/account',
                    targetTab: 'tab-5',
                  });
                } else if (ticket.orderState?.value === 'init') {
                  history.push(`/ticket-refund/info/${ticket._id}`, {
                    prevPage: '/account',
                    targetTab: 'tab-4',
                  });
                }
              } else if (
                ticket.orderType?.value === 'upgrade' ||
                ticket.orderType === 'upgrade'
              ) {
                if (ticket?.agent?.id === infoUser?.id) {
                  history.push(`/check-tickets/select-tickets/${ticket._id}`, {
                    prevPage: '/account',
                    targetTab: 'tab-3',
                  });
                } else {
                  history.push('/page-not-found');
                }
              } else {
                onClickShowDetail(ticket);
              }
            }}
            textColor="white"
            width={'auto'}
          >
            <img
              src={Images.IconEyes}
              alt=""
              style={{
                ...((isDisable || isPartnerViewAdjustedFocOrPriceOrder) &&
                  disableStyle),
              }}
            />
          </StyledButton>
        </Tooltip>
      )}
      <DialogWarning
        open={warning.open}
        message={warning.message}
        onClose={() => setWarning({ open: false, message: '' })}
        maskClosable={true}
      />
    </StyledStack>
  );
};

export const StyledCollapse = styled(Collapse)`
  border: none;
  background-color: #ffffff;
  .ticket-info-title {
    margin-bottom: 0px !important;
  }
  .ant-collapse-expand-icon {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-collapse-header {
    background-color: #ffffff;
    margin-bottom: 24px;
  }
  .ant-collapse-item {
    border: none;
  }
  .ant-collapse-header {
    padding: 0 !important;
  }
  .ant-collapse-content {
    border: none;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export const Countdown = ({
  onTimeout,
  orderCheckout,
  noText,
}: {
  onTimeout?: () => void;
  orderCheckout?: TicketType;
  noText?: boolean;
}) => {
  const isTimeout = useRef(false);
  const translations = useSelector(selectTranslations);
  const expiredAt = moment(
    orderCheckout?.expiredAt?.datetimeDMYHIS ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const startTime = moment(
    orderCheckout?.startTime?.datetimeDMYHIS ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const time = expiredAt.valueOf() - startTime.valueOf();
  const { timeRemaining } = useCountDown({
    time: time < 0 ? 0 : time,
    interval: 1000,
    startTime: startTime.valueOf(),
  });
  const { minutes, seconds, hours } = parseSecondsToMinutesAndHours(
    timeRemaining / 1000,
  );

  useEffect(() => {
    if (timeRemaining <= 0 && !isTimeout.current) {
      onTimeout && onTimeout();
      isTimeout.current = true;
    }
  }, [timeRemaining, onTimeout]);

  useEffect(() => {
    return () => {
      isTimeout.current = true;
    };
  }, []);
  const antIcon = useMemo(
    () => <LoadingOutlined style={{ fontSize: 16, color: '#E92127' }} spin />,
    [],
  );
  return (
    <div>
      {!noText && translations ? translations['b2b.txt.payIn'] : ''}{' '}
      {timeRemaining === 48 * 60 * 60 * 1000 ? (
        antIcon
      ) : (
        <span style={{ color: '#E92127' }}>{`${hours < 10 ? '0' : ''}${hours}:${
          minutes < 10 ? '0' : ''
        }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}</span>
      )}
    </div>
  );
};

export default ListTicketLayout;

export const OrderInfoView = ({
  ticket,
  setIsCreatingPayment,
  isShowButtonPay,
  isCreatingPayment,
  search,
  isAbleCancelOrder,
  onCancelOrderSuccess,
  onlyShowPayButton,
}: {
  ticket: TicketType;
  isShowButtonPay?: boolean;
  setIsCreatingPayment?: (isCreating: boolean) => void;
  isCreatingPayment?: boolean;
  search?: (payload: Partial<I_PayloadGetListOrder>) => void;
  isAbleCancelOrder?: boolean;
  onCancelOrderSuccess?: () => void;
  onlyShowPayButton?: boolean;
}) => {
  const { Panel } = Collapse;
  const { device } = useWindowSize();
  const history = useHistory();
  const translations = useSelector(selectTranslations);
  const antIcon = useMemo(
    () => <LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />,
    [],
  );
  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const payOrder = useCallback(async () => {
    try {
      setIsCreatingPayment?.(true);
      // setSessionItem(TYPE_LOCAL_STORAGE.ORDER, JSON.stringify(ticket._id));
      if (ticket?.orderType?.value === 'upgrade') {
        history.push('/check-tickets/confirm-policy-order/' + ticket._id, {
          menu: ACCOUNT_MNG_MENU.PURCHASE_HISTORY,
        });
      } else {
        history.push('/checkout/' + ticket._id);
      }
    } catch (e) {
    } finally {
      setIsCreatingPayment?.(false);
    }
  }, [history, setIsCreatingPayment, ticket._id]);

  const isProxyOrder = !!ticket.emailBpAllocatedDebt;
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  return (
    <Row>
      <Col span={device === 'mobile' ? 24 : 12}>
        {device === 'mobile' && (
          <StyledCollapse defaultActiveKey="1">
            <Panel
              key={'1'}
              header={
                <div className="d-flex">
                  <TicketInfoTitle
                    className="ticket-info-title"
                    style={{
                      marginBottom: 24,
                    }}
                  >
                    {translations ? translations['b2c.txt.info-order'] : ''}
                  </TicketInfoTitle>
                  <div
                    style={{
                      padding: '4px 8px',
                      whiteSpace: 'nowrap',
                      background: '#F54949',
                      borderRadius: '8px',
                      color: 'white',
                      height: '25px',
                      fontSize: '12px',
                      marginLeft: 20,
                    }}
                  >
                    {
                      translations?.[
                        `${
                          ticket?.isLongTerm
                            ? 'b2b.txt.long-term'
                            : 'b2b.txt.short-term'
                        }`
                      ]
                    }
                  </div>
                </div>
              }
            >
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.orderNumber'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                  {ticket.orderInfo.orderId}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.ticketAmount'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                  {ticket.orderInfo.amountOfTicket}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.date-order'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                  {DateFormat.create(
                    'HH:mm DD/MM/YYYY',
                    ticket.orderInfo.orderDate,
                  )
                    .getMoment()
                    ?.format('DD/MM/YYYY') ?? ''}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2b.table.payment'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue style={{ paddingLeft: 8 }}>
                  {ticket.orderInfo.payment?.name ?? ''}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2b.txt.total-discount'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue
                  style={{
                    color: '#F8B117',
                    paddingLeft: 8,
                  }}
                >
                  {formatNumber(-ticket.orderInfo.totalDiscountValue)}
                  {'đ'}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.total-amount'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue
                  style={{
                    color: '#e92127',
                    paddingLeft: 8,
                  }}
                >
                  {formatNumber(ticket.orderInfo.totalPriceValue)}
                  {'đ'}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              {!!ticket?.adjustedPriceOrFOC && (
                <>
                  {['init', 'pendingApprove'].includes(
                    ticket?.orderState?.value,
                  ) && (
                    <>
                      <StyledDivider dashed />
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations
                            ? translations['b2b.txt.order-status']
                            : ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue
                          style={{
                            color: '#e92127',
                            paddingLeft: 8,
                          }}
                        >
                          {!!ticket?.approvedDate
                            ? translations?.['b2b.txt.approved'] ?? ''
                            : ticket.orderState.name}
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                    </>
                  )}
                  {!!ticket?.approveReason && (
                    <>
                      <StyledDivider dashed />
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations?.['b2b.txt.reasonForApproval'] ?? ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue>
                          {ticket?.approveReason}
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                    </>
                  )}
                  {!!ticket?.adjustAttach && (
                    <>
                      <StyledDivider dashed />
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations?.['b2b.txt.proposalDocument'] ?? ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue>
                          <TooltipParagraph
                            ellipsis={{ rows: 2 }}
                            style={{
                              marginBottom: 0,
                              textAlign: 'left',
                              color: '#f8b117',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                            onClick={clickToDownload.bind(
                              null,
                              ticket?.adjustAttach,
                            )}
                          >
                            {ticket?.adjustAttach}
                          </TooltipParagraph>
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                    </>
                  )}
                </>
              )}
            </Panel>
          </StyledCollapse>
        )}
        {(device === 'desktop' || device === 'tablet') && (
          <div>
            <Row style={{ width: '92%' }}>
              <TicketInfoTitle
                className="ticket-info-title"
                style={{
                  marginBottom: 16,
                  marginTop: 16,
                }}
              >
                {translations ? translations['b2c.txt.info-order'] : ''}
              </TicketInfoTitle>
              <div
                style={{
                  padding: '4px 8px',
                  whiteSpace: 'nowrap',
                  background: '#F54949',
                  borderRadius: '8px',
                  color: 'white',
                  height: '25px',
                  fontSize: '12px',
                  marginLeft: 'auto',
                  marginBottom: 16,
                  marginTop: 16,
                }}
              >
                {
                  translations?.[
                    `${
                      ticket?.isLongTerm
                        ? 'b2b.txt.long-term'
                        : 'b2b.txt.short-term'
                    }`
                  ]
                }
              </div>
            </Row>
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.orderNumber'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
              >
                {ticket.orderInfo.orderId}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.ticketAmount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
              >
                {ticket.orderInfo.amountOfTicket}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.date-order'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
              >
                {DateFormat.create(
                  'HH:mm DD/MM/YYYY',
                  ticket.orderInfo.orderDate,
                )
                  .getMoment()
                  ?.format('DD/MM/YYYY') ?? ''}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey style={{ paddingRight: 9 }}>
                {translations ? translations['b2b.table.payment'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  paddingLeft: 8,
                }}
              >
                {ticket.orderInfo.payment?.name ?? ''}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2b.txt.total-discount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  color: '#F8B117',
                  paddingLeft: 8,
                }}
              >
                {formatNumber(-ticket.orderInfo.totalDiscountValue)}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.total-amount'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue
                style={{
                  color: '#e92127',
                  paddingLeft: 8,
                }}
              >
                {formatNumber(ticket.orderInfo.totalPriceValue)}
                {'đ'}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>

            {!!ticket?.adjustedPriceOrFOC && (
              <>
                {['init', 'pendingApprove'].includes(
                  ticket?.orderState?.value,
                ) && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations
                          ? translations['b2b.txt.order-status']
                          : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue
                        style={{
                          color: '#e92127',
                          paddingLeft: 8,
                        }}
                      >
                        {!!ticket?.approvedDate
                          ? translations?.['b2b.txt.approved'] ?? ''
                          : ticket.orderState.name}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}

                {!!ticket?.approveReason && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations?.['b2b.txt.reasonForApproval'] ?? ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        {ticket?.approveReason}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}

                {!!ticket?.adjustAttach && (
                  <>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations
                          ? translations['b2b.txt.proposalDocument']
                          : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                            color: '#f8b117',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            paddingRight: 5,
                          }}
                          onClick={clickToDownload.bind(
                            null,
                            ticket?.adjustAttach,
                          )}
                        >
                          {ticket?.adjustAttach}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </>
                )}
              </>
            )}
          </div>
        )}

        {(device === 'desktop' || device === 'tablet') &&
          !!ticket?.representativesInfo?.length && (
            <Row>
              {/* Thông tin người đại diện */}
              <Col span={24}>
                <TicketInfoTitle
                  className="ticket-info-title"
                  style={{
                    marginTop: 32,
                  }}
                >
                  {translations ? translations['b2b.txt.representiveInfo'] : ''}
                </TicketInfoTitle>
              </Col>

              {ticket?.representativesInfo?.map((item, index) => (
                <Col span={24} key={index} style={{ marginBottom: '8px' }}>
                  <div>
                    <TicketInfoTitle
                      className="ticket-info-title"
                      style={{
                        marginBottom: 16,
                        marginTop: 16,
                        fontSize: '14px',
                      }}
                    >
                      {translations
                        ? translations['b2b.txt.agent-referrer'] +
                          ' ' +
                          (index + 1)
                        : ''}
                    </TicketInfoTitle>
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations
                          ? translations['b2b.form.namePlaceholder']
                          : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        {item?.name}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations ? translations['b2b.acc.phone'] : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        {item?.phone}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        {translations ? translations['b2b.acc.email'] : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        {item?.email}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                    <StyledDivider dashed />
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey
                        style={{ paddingRight: 9 }}
                      >
                        {translations ? translations['b2b.txt.position'] : ''}
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue
                        style={{
                          paddingLeft: 8,
                        }}
                      >
                        {translations?.['b2b.txt.' + item?.position]}
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>
                  </div>
                </Col>
              ))}
            </Row>
          )}
      </Col>

      <Col span={12}>
        {(device === 'desktop' || device === 'tablet') && (
          <div>
            <TicketInfoTitle
              style={{
                marginBottom: 16,
                marginTop: 16,
              }}
            >
              {translations
                ? translations[
                    isProxyOrder && !isProxyBuyer
                      ? 'b2b.txt.saleSupportInfo'
                      : 'b2c.txt.info-pay'
                  ] ?? 'Thông tin hỗ trợ bán hàng'
                : ''}
            </TicketInfoTitle>
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.customer'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue>
                {ticket.paymentInfo.customerName}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                {translations ? translations['b2c.txt.phone'] : ''}
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue>
                {ticket.paymentInfo.phoneNumber}
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                Email
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue>
                <TooltipParagraph
                  ellipsis={{ rows: 2 }}
                  style={{
                    marginBottom: 0,
                    textAlign: 'left',
                  }}
                >
                  {ticket.paymentInfo.email || ''}
                </TooltipParagraph>
              </ColTicketInfo.ColTicketInfoValue>
            </Row>
            <StyledDivider dashed />
            {isShowButtonPay && !isProxyOrder && (
              <>
                <Row>
                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <StyledButton
                      style={{
                        height: 44,
                        minWidth: 171,
                        marginRight: 8,
                      }}
                      onClick={payOrder}
                      textColor="white"
                      width={'auto'}
                    >
                      {isCreatingPayment && antIcon}
                      {translations?.['b2b.txt.pay-now'] ?? ''}
                    </StyledButton>
                    {!onlyShowPayButton && (
                      <div>
                        {ticket.expiredAt && (
                          <Countdown
                            onTimeout={() => search?.({})}
                            orderCheckout={ticket}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
                {!onlyShowPayButton && (
                  <Row>
                    <Col>
                      <StyledButton
                        style={{
                          marginTop: 8,
                          height: 44,
                          minWidth: 171,
                        }}
                        onClick={() =>
                          windowOpenLink({
                            url: `/update-order-info?order_id=${ticket._id}`,
                            target: '_self',
                          })
                        }
                        textColor="white"
                        width={'auto'}
                      >
                        {translations?.['b2b.txt.input-customer-info'] ?? ''}
                      </StyledButton>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </div>
        )}

        {(device === 'desktop' || device === 'tablet') && isProxyOrder && (
          <div>
            <div
              className={`${
                isProxyOrder && !isProxyBuyer ? 'd-none' : 'd-block'
              }`}
            >
              <TicketInfoTitle
                style={{
                  marginBottom: 16,
                  marginTop: 32,
                }}
              >
                {translations ? translations['b2b.txt.partnerInfo'] : ''}
              </TicketInfoTitle>
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2b.txt.partnerName'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {(ticket as any)?.businessPartnerAllocatedDebt?.name}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2b.acc.address'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {(ticket as any)?.businessPartnerAllocatedDebt?.address}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2b.acc.email'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  <TooltipParagraph
                    ellipsis={{ rows: 2 }}
                    style={{
                      marginBottom: 0,
                      textAlign: 'left',
                    }}
                  >
                    {(ticket as any)?.businessPartnerAllocatedDebt?.emailAgent}
                  </TooltipParagraph>
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
            </div>

            <TicketInfoTitle
              style={{
                marginBottom: 16,
                marginTop: 32,
              }}
            >
              {translations ? translations['b2b.txt.ticketRecipientInfo'] : ''}
            </TicketInfoTitle>
            <Row>
              <ColTicketInfo.ColTicketInfoKey>
                Email
              </ColTicketInfo.ColTicketInfoKey>
              <ColTicketInfo.ColTicketInfoValue>
                <TooltipParagraph
                  ellipsis={{ rows: 2 }}
                  style={{
                    marginBottom: 0,
                    textAlign: 'left',
                  }}
                >
                  {(ticket as any)?.emailBpAllocatedDebt}
                </TooltipParagraph>
              </ColTicketInfo.ColTicketInfoValue>
            </Row>

            {!!(ticket as any)?.approvedCode && (
              <>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations?.['b2b.txt.approvalCode'] ?? ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue>
                    <TooltipParagraph
                      ellipsis={{ rows: 2 }}
                      style={{
                        marginBottom: 0,
                        textAlign: 'left',
                      }}
                    >
                      {(ticket as any)?.approvedCode}
                    </TooltipParagraph>
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
              </>
            )}

            {!!(ticket as any)?.approveAttach && (
              <>
                <StyledDivider dashed />
                <Row>
                  <ColTicketInfo.ColTicketInfoKey>
                    {translations?.['b2b.txt.approvalDoc'] ?? ''}
                  </ColTicketInfo.ColTicketInfoKey>
                  <ColTicketInfo.ColTicketInfoValue>
                    <TooltipParagraph
                      ellipsis={{ rows: 2 }}
                      style={{
                        marginBottom: 0,
                        textAlign: 'left',
                        color: '#f8b117',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                      onClick={clickToDownload.bind(
                        null,
                        (ticket as any)?.approveAttach,
                      )}
                    >
                      {(ticket as any)?.approveAttach}
                    </TooltipParagraph>
                  </ColTicketInfo.ColTicketInfoValue>
                </Row>
              </>
            )}

            <StyledDivider dashed />
            {isShowButtonPay && (
              <>
                <Row>
                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <StyledButton
                      style={{
                        height: 44,
                        minWidth: 171,
                        marginRight: 8,
                      }}
                      onClick={payOrder}
                      textColor="white"
                      width={'auto'}
                    >
                      {isCreatingPayment && antIcon}
                      {translations?.['b2b.txt.pay-now'] ?? ''}
                    </StyledButton>
                    {!onlyShowPayButton && (
                      <div>
                        {ticket.expiredAt && (
                          <Countdown
                            onTimeout={() => search?.({})}
                            orderCheckout={ticket}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
                {!onlyShowPayButton && (
                  <Row>
                    <Col>
                      <StyledButton
                        style={{
                          marginTop: 8,
                          height: 44,
                          minWidth: 171,
                        }}
                        onClick={() =>
                          windowOpenLink({
                            url: `/update-order-info?order_id=${ticket._id}`,
                            target: '_self',
                          })
                        }
                        textColor="white"
                        width={'auto'}
                      >
                        {translations?.['b2b.txt.input-customer-info'] ?? ''}
                      </StyledButton>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </div>
        )}
      </Col>

      {device === 'mobile' && (
        <Col span={24} style={{ marginTop: 32 }}>
          <StyledCollapse defaultActiveKey="1">
            <Panel
              key={'1'}
              header={
                <TicketInfoTitle
                  className="ticket-info-title"
                  style={{
                    marginBottom: 24,
                  }}
                >
                  {translations
                    ? translations[
                        isProxyOrder && !isProxyBuyer
                          ? 'b2b.txt.saleSupportInfo'
                          : 'b2c.txt.info-pay'
                      ] ?? 'Thông tin hỗ trợ bán hàng'
                    : ''}
                </TicketInfoTitle>
              }
            >
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.customer'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {ticket.paymentInfo.customerName}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  {translations ? translations['b2c.txt.phone'] : ''}
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  {ticket.paymentInfo.phoneNumber}
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              <Row>
                <ColTicketInfo.ColTicketInfoKey>
                  Email
                </ColTicketInfo.ColTicketInfoKey>
                <ColTicketInfo.ColTicketInfoValue>
                  <TooltipParagraph
                    ellipsis={{ rows: 2 }}
                    style={{
                      marginBottom: 0,
                      textAlign: 'left',
                    }}
                  >
                    {ticket.paymentInfo.email || ''}
                  </TooltipParagraph>
                </ColTicketInfo.ColTicketInfoValue>
              </Row>
              <StyledDivider dashed />
              {isShowButtonPay && !isProxyOrder && (
                <>
                  <Row>
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <StyledButton
                        style={{
                          height: 44,
                          minWidth: 161,
                          marginRight: 8,
                        }}
                        textColor="white"
                        width={'auto'}
                        onClick={payOrder}
                      >
                        {translations?.['b2b.txt.pay-now'] ?? ''}
                      </StyledButton>
                      {!onlyShowPayButton && (
                        <div>
                          {ticket?.expiredAt && (
                            <Countdown
                              onTimeout={() => search?.({})}
                              orderCheckout={ticket}
                            />
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                  {!onlyShowPayButton && (
                    <Row>
                      <Col>
                        <StyledButton
                          style={{
                            marginTop: 8,
                            height: 44,
                            minWidth: 161,
                          }}
                          onClick={() =>
                            windowOpenLink({
                              url: `/update-order-info?order_id=${ticket._id}`,
                              target: '_self',
                            })
                          }
                          textColor="white"
                          width={'auto'}
                        >
                          {translations?.['b2b.txt.input-customer-info'] ?? ''}
                        </StyledButton>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Panel>
          </StyledCollapse>
        </Col>
      )}

      {device === 'mobile' && (
        <>
          {!!ticket?.representativesInfo?.length && (
            <Col span={24}>
              <Row>
                {/* Thông tin người đại diện */}
                <Col span={24}>
                  <TicketInfoTitle
                    className="ticket-info-title"
                    style={{
                      marginTop: 32,
                    }}
                  >
                    {translations
                      ? translations['b2b.txt.representiveInfo']
                      : ''}
                  </TicketInfoTitle>
                </Col>
                {ticket?.representativesInfo?.map((item, index) => (
                  <Col span={24} key={index}>
                    <StyledCollapse defaultActiveKey="1">
                      <Panel
                        style={{
                          marginBottom: 16,
                          marginTop: 16,
                          fontSize: '14px',
                        }}
                        key={'1'}
                        header={
                          <TicketInfoTitle
                            className="ticket-info-title"
                            style={{
                              fontSize: '14px',
                            }}
                          >
                            {translations
                              ? translations['b2b.txt.agent-referrer'] +
                                ' ' +
                                (index + 1)
                              : ''}
                          </TicketInfoTitle>
                        }
                      >
                        <Col
                          span={24}
                          key={index}
                          style={{ marginBottom: '8px' }}
                        >
                          <Row>
                            <ColTicketInfo.ColTicketInfoKey>
                              {translations
                                ? translations['b2b.form.namePlaceholder']
                                : ''}
                            </ColTicketInfo.ColTicketInfoKey>
                            <ColTicketInfo.ColTicketInfoValue
                              style={{
                                paddingLeft: 8,
                              }}
                            >
                              {item?.name}
                            </ColTicketInfo.ColTicketInfoValue>
                          </Row>
                          <StyledDivider dashed />
                          <Row>
                            <ColTicketInfo.ColTicketInfoKey>
                              {translations
                                ? translations['b2b.acc.phone']
                                : ''}
                            </ColTicketInfo.ColTicketInfoKey>
                            <ColTicketInfo.ColTicketInfoValue
                              style={{
                                paddingLeft: 8,
                              }}
                            >
                              {item?.phone}
                            </ColTicketInfo.ColTicketInfoValue>
                          </Row>
                          <StyledDivider dashed />
                          <Row>
                            <ColTicketInfo.ColTicketInfoKey>
                              {translations
                                ? translations['b2b.acc.email']
                                : ''}
                            </ColTicketInfo.ColTicketInfoKey>
                            <ColTicketInfo.ColTicketInfoValue
                              style={{
                                paddingLeft: 8,
                              }}
                            >
                              {item?.email}
                            </ColTicketInfo.ColTicketInfoValue>
                          </Row>
                          <StyledDivider dashed />
                          <Row>
                            <ColTicketInfo.ColTicketInfoKey
                              style={{ paddingRight: 9 }}
                            >
                              {translations
                                ? translations['b2b.txt.position']
                                : ''}
                            </ColTicketInfo.ColTicketInfoKey>
                            <ColTicketInfo.ColTicketInfoValue
                              style={{
                                paddingLeft: 8,
                              }}
                            >
                              {translations?.['b2b.txt.' + item?.position]}
                            </ColTicketInfo.ColTicketInfoValue>
                          </Row>
                        </Col>
                      </Panel>
                    </StyledCollapse>
                  </Col>
                ))}
              </Row>
            </Col>
          )}
          {device === 'mobile' && isProxyOrder && (
            <>
              {isProxyOrder && isProxyBuyer && (
                <Col span={24} style={{ marginTop: 32 }}>
                  <StyledCollapse defaultActiveKey="1">
                    <Panel
                      key={'1'}
                      header={
                        <TicketInfoTitle
                          className="ticket-info-title"
                          style={{
                            marginBottom: 24,
                          }}
                        >
                          {translations
                            ? translations['b2b.txt.partnerInfo']
                            : ''}
                        </TicketInfoTitle>
                      }
                    >
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations
                            ? translations['b2b.txt.partnerName']
                            : ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue>
                          {(ticket as any)?.businessPartnerAllocatedDebt?.name}
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                      <StyledDivider dashed />
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations ? translations['b2b.acc.address'] : ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue>
                          {
                            (ticket as any)?.businessPartnerAllocatedDebt
                              ?.address
                          }
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                      <StyledDivider dashed />
                      <Row>
                        <ColTicketInfo.ColTicketInfoKey>
                          {translations ? translations['b2b.acc.email'] : ''}
                        </ColTicketInfo.ColTicketInfoKey>
                        <ColTicketInfo.ColTicketInfoValue>
                          <TooltipParagraph
                            ellipsis={{ rows: 2 }}
                            style={{
                              marginBottom: 0,
                              textAlign: 'left',
                            }}
                          >
                            {
                              (ticket as any)?.businessPartnerAllocatedDebt
                                ?.emailAgent
                            }
                          </TooltipParagraph>
                        </ColTicketInfo.ColTicketInfoValue>
                      </Row>
                      <StyledDivider dashed />
                    </Panel>
                  </StyledCollapse>
                </Col>
              )}

              <Col span={24} style={{ marginTop: 32 }}>
                <StyledCollapse defaultActiveKey="1">
                  <Panel
                    key={'1'}
                    header={
                      <TicketInfoTitle
                        className="ticket-info-title"
                        style={{
                          marginBottom: 24,
                        }}
                      >
                        {translations
                          ? translations['b2b.txt.ticketRecipientInfo']
                          : ''}
                      </TicketInfoTitle>
                    }
                  >
                    <Row>
                      <ColTicketInfo.ColTicketInfoKey>
                        Email
                      </ColTicketInfo.ColTicketInfoKey>
                      <ColTicketInfo.ColTicketInfoValue>
                        <TooltipParagraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            marginBottom: 0,
                            textAlign: 'left',
                          }}
                        >
                          {(ticket as any)?.emailBpAllocatedDebt}
                        </TooltipParagraph>
                      </ColTicketInfo.ColTicketInfoValue>
                    </Row>

                    {!!(ticket as any)?.approvedCode && (
                      <>
                        <StyledDivider dashed />
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey>
                            {translations?.['b2b.txt.approvalCode'] ?? ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue>
                            <TooltipParagraph
                              ellipsis={{ rows: 2 }}
                              style={{
                                marginBottom: 0,
                                textAlign: 'left',
                              }}
                            >
                              {(ticket as any)?.approvedCode}
                            </TooltipParagraph>
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                      </>
                    )}

                    {!!(ticket as any)?.approveAttach && (
                      <>
                        <StyledDivider dashed />
                        <Row>
                          <ColTicketInfo.ColTicketInfoKey>
                            {translations?.['b2b.txt.approvalDoc'] ?? ''}
                          </ColTicketInfo.ColTicketInfoKey>
                          <ColTicketInfo.ColTicketInfoValue>
                            <TooltipParagraph
                              ellipsis={{ rows: 2 }}
                              style={{
                                marginBottom: 0,
                                textAlign: 'left',
                                color: '#f8b117',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              }}
                              onClick={clickToDownload.bind(
                                null,
                                (ticket as any)?.approveAttach,
                              )}
                            >
                              {(ticket as any)?.approveAttach}
                            </TooltipParagraph>
                          </ColTicketInfo.ColTicketInfoValue>
                        </Row>
                      </>
                    )}

                    <StyledDivider dashed />
                  </Panel>
                </StyledCollapse>
              </Col>
              {isShowButtonPay && (
                <>
                  <Row>
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <StyledButton
                        style={{
                          height: 44,
                          minWidth: 171,
                          marginRight: 8,
                        }}
                        onClick={payOrder}
                        textColor="white"
                        width={'auto'}
                      >
                        {isCreatingPayment && antIcon}
                        {translations?.['b2b.txt.pay-now'] ?? ''}
                      </StyledButton>
                      {!onlyShowPayButton && (
                        <div>
                          {ticket.expiredAt && (
                            <Countdown
                              onTimeout={() => search?.({})}
                              orderCheckout={ticket}
                            />
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>
                  {!onlyShowPayButton && (
                    <Row>
                      <Col>
                        <StyledButton
                          style={{
                            marginTop: 8,
                            height: 44,
                            minWidth: 171,
                          }}
                          onClick={() =>
                            windowOpenLink({
                              url: `/update-order-info?order_id=${ticket._id}`,
                              target: '_self',
                            })
                          }
                          textColor="white"
                          width={'auto'}
                        >
                          {translations?.['b2b.txt.input-customer-info'] ?? ''}
                        </StyledButton>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      <Col span={24}>
        <Row>
          {isAbleCancelOrder && (
            <Col span={24} className="d-flex justify-content-end">
              <CancelOrderComponent
                idHash={ticket?._id ?? ''}
                isDisable={
                  (!isSaleMng &&
                    ticket.paymentInfo.email !== infoUser?.username) ||
                  (isProxyOrder && !isProxyBuyer)
                }
                onCancelOrderSuccess={onCancelOrderSuccess}
              />
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export const CancelOrderComponent = ({
  isExchange,
  idHash,
  onCancelOrderSuccess,
  isDisable,
}: {
  isExchange?: boolean;
  idHash: string;
  onCancelOrderSuccess?: () => void;
  isDisable?: boolean;
}) => {
  const translations = useSelector(selectTranslations);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const [isRemoving, setIsRemoving] = useState(false);

  const antIcon = useMemo(
    () => <LoadingOutlined style={{ fontSize: 16, color: '#F8B117' }} spin />,
    [],
  );

  const onCancelOrder = async () => {
    try {
      setIsRemoving(true);
      onCloseDialogNoti();
      const formData = new FormData();
      formData.append('idHash', idHash);
      const api = isExchange ? cancelUpgradeTicketApi : cancelOrderApi;
      const response = await api(formData);
      if (response?.status === 200) {
        onCancelOrderSuccess?.();
      }
    } catch (err: any) {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content:
          err?.message ?? translations?.['b2b.txt.cancelOrderFailed'] ?? '',
        onCloseDialog: onCloseDialogNoti,
      });
    } finally {
      setIsRemoving(false);
    }
  };

  const handleClick = () => {
    if (isRemoving) return;

    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: '',
      content: translations?.['b2b.txt.cfRemoveOrder'] ?? '',
      closable: false,
      buttons: [
        {
          text: translations?.['b2b.txt.back'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2b.txt.cancel-order'] ?? '',
          bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
          color: 'white',
          onClick: onCancelOrder,
        },
      ],
    });
  };

  return (
    <div
      className="d-flex align-items-center"
      style={{ cursor: isDisable ? 'not-allowed' : 'pointer' }}
      onClick={isDisable ? undefined : handleClick}
    >
      {isRemoving ? (
        antIcon
      ) : isDisable ? (
        <CancelOrderIconDisable />
      ) : (
        <CancelOrderIcon />
      )}
      <span style={{ color: isDisable ? '#808080' : '#F8B117', marginLeft: 8 }}>
        {translations?.['b2b.txt.cancel-order'] ?? ''}
      </span>
    </div>
  );
};
